import React from 'react';
import styled from 'styled-components';
import { getTileImagePath, getTileText } from '../utils/tileUtils';

const Tile = ({ tile, onClick, isSelectable = false, isSelected = false }) => {
  const handleClick = () => {
    if (isSelectable && onClick) {
      onClick(tile);
    }
  };

  // 타일 배경색 (이미지 대신 색상 사용)
  const tileColor = tile ? getTileImagePath(tile) : '#1a4d2e';
  
  // 타일 텍스트 (이미지 대신 텍스트 표시)
  const tileText = tile ? getTileText(tile) : '';

  return (
    <TileContainer 
      onClick={handleClick} 
      isSelectable={isSelectable}
      isSelected={isSelected}
    >
      {tile ? (
        <TileContent 
          backgroundColor={tileColor}
        >
          <TileText>{tileText}</TileText>
        </TileContent>
      ) : (
        <TileBack />
      )}
    </TileContainer>
  );
};

const TileContainer = styled.div`
  width: 40px;
  height: 56px;
  margin: 2px;
  border-radius: 4px;
  background-color: #f8f8f8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => props.isSelectable ? 'pointer' : 'default'};
  transform: ${props => props.isSelected ? 'translateY(-8px)' : 'none'};
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    box-shadow: ${props => props.isSelectable ? '0 4px 8px rgba(0, 0, 0, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.2)'};
    transform: ${props => props.isSelectable ? 'translateY(-4px)' : 'none'};
  }
  
  &:active {
    transform: ${props => props.isSelectable ? 'translateY(-2px)' : 'none'};
  }
`;

// 이미지 대신 색상과 텍스트로 타일 표시
const TileContent = styled.div`
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backgroundColor};
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.2);
`;

const TileText = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.8);
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.5);
`;

const TileBack = styled.div`
  width: 90%;
  height: 90%;
  background-color: #1a4d2e;
  border-radius: 2px;
  background-image: linear-gradient(45deg, #143d28 25%, transparent 25%, transparent 75%, #143d28 75%, #143d28),
                    linear-gradient(45deg, #143d28 25%, transparent 25%, transparent 75%, #143d28 75%, #143d28);
  background-size: 10px 10px;
  background-position: 0 0, 5px 5px;
`;

export default Tile;
